import { templateParseToElement } from "../../logic/templateParse.js";
import { ComuneInputComponent } from "../ambito-input/comune-input.js";
import { DataBaseComponent } from "./data-base-component.js";
export class DataComuneComponent extends DataBaseComponent {
    static webComponentName: string = "data-comune";
    protected _templateId: string = "data-comune-component"; // Template ID for rendering
    protected inputType: string = "text"; // Default input type for ambito fields
    protected comuneComponent:ComuneInputComponent|null=null; // Reference to the ambito input component
    protected rendered: boolean = false;
    get readOnly(): boolean {
        return this.hasAttribute('readonly') || this.hasAttribute('disabled') ||
        this.dataSlotElement?.hasAttribute('readonly') || this.dataSlotElement?.hasAttribute('disabled');
    }
    constructor() {
        super();
        
    }

    get value(): any {
        let v: any = null;
        if (this.comuneComponent && this.rendered) {
            v =  this.comuneComponent.value;
        }
        else {
            v = super.value;
        }
        if(Array.isArray(v)) {
            v = v.length>0?v[0]:null;
        }
        return v;
    }
    set value(newValue: any) {
        super.value = newValue;
    }
    protected setupSyncEventListeners(): void {} // No sync events needed
    addDataForTemplate(): Record<string, any> {
        const initialValue = this.value;
        
        return {
            inputType: this.inputType, // Pass the input type to the template
            field:this.field, // Include field metadata
            readonly: this.readOnly, // Pass readOnly state
            initialValue
        };
    }
    protected afterRender(): void {
        super.afterRender();
        this.comuneComponent = this.querySelector<ComuneInputComponent>('comune-input');
        if(this.comuneComponent) {
            this.rendered = true;
        }
        window.testComuneComponent = ()=> {
            return this.comuneComponent.value;
        }
    }
    protected render(): void {
        templateParseToElement(this.templateId, this,this.addDataForTemplate());
        this.afterRender();
    }
}